module.exports = __webpack_public_path__ + "img/practice-2.226a760b.jpg";